import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";
//------------------master-API-country---------------------------
export const countryApi = async () => {
  return await axios.get(`/master/country`);
};
//------------------master-API-state---------------------------
export const stateApi = async (data) => {
  const endPoint =
    `/master/state` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint);
};
//------------------master-API-city---------------------------
export const cityApi = async (data) => {
  const endPoint =
    `/master/city` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint);
};
export const masterCategory = async (data) => {
  const endPoint =
    `/master/get_category` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint);
};
